"use client"

import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(): React.ReactElement | null {
  const location = useLocation();

  useEffect(() => {
    try {
      if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
      }
    } catch (e) { }
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const prefersReducedMotion =
        window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: prefersReducedMotion ? "auto" : "smooth",
      });
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}
